import { Config, CurrentConfig } from './types/config';

export const config: Config = {
  app: {
    description: 'Tripenger - Your trusted platform for seamless travel planning and flight bookings.',
    name: 'Tripenger',
    contactNumber: '+353 1 726 5406',
    supportEmail: 'trips@tripenger.com',
    addressSA: 'Tripenger, Cape Town, South Africa',
    addressIR: 'Unit 2, 2 Bridge Street Athlone, Westmeath, Ireland. N37 F1W4',
    maxAdultTravellers: 9,
    maxChildrenTravellers: 9,
    maxInfantTravellers: 9,
    JWTStorageKey: '365b166cfab249b2eeab45a68a4e8c27',
    helpCenterLink: '/info',
    googleAnalyticsId: 'G-V6YQPZ6T0Z',
    googleAdsId: 'AW-18542366472',
    posthogProjectApiKey: 'phc_Ckaz3hx2FRfTuJy6TUpmbBD35Sk4VGzg3boSA4FBeX2Q',
    posthogApiHost: 'https://eu.i.posthog.com',
    posthogDefaults: '2026-05-30',
    posthogPersonProfiles: 'identified_only',
  },
  prod: {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.tripenger.com/',
    featureFlag: {
      onlyRegisteredUsersCanAccess: false,
      disableUserRegistration: false,
      captchaEnabled: true,
    },
    recaptchaSiteKey: '6LfEx28rAAAAAAkfaEXlIcfsjJa3pW3ZYbKpVge8',
  },
  dev: {
    apiBaseUrl: 'http://localhost:3100/',
    featureFlag: {
      onlyRegisteredUsersCanAccess: false,
      disableUserRegistration: false,
      captchaEnabled: true,
    },
    recaptchaSiteKey: '6LfEx28rAAAAAAkfaEXlIcfsjJa3pW3ZYbKpVge8',
  },
};

const getConfig = (env: 'prod' | 'dev'): CurrentConfig => {
  return {
    app: config.app,
    env: config[env],
  };
};

export const CONFIG = getConfig(
  process.env?.NODE_ENV.toLowerCase() === 'development' ? 'dev' : 'prod',
);
